// extracted by mini-css-extract-plugin
export default {"container":"MergeAccountContainer_container__UoxCy","sectionContainer":"MergeAccountContainer_sectionContainer__sOg0f"};